{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Keni kaluar kufirin e bisedave. Plani Hacker lejon vetëm 500 biseda.",
      "INBOXES": "Keni kaluar kufirin e kutive hyrëse. Plani Hacker mbështet vetëm chat-in e drejtpërdrejtë në faqen e internetit. Kutitë hyrëse shtesë si email, WhatsApp etj. kërkojnë një plan me pagesë.",
      "AGENTS": "Keni kaluar kufirin e agjentëve. Plani Hacker lejon vetëm 2 agjentë.",
      "NON_ADMIN": "Kontaktoni administratorin tuaj për ta përmirësuar planin dhe për të vazhduar të përdorni të gjitha funksionet."
    },
    "TITLE": "Account settings",
    "SUBMIT": "Update settings",
    "BACK": "Back",
    "DISMISS": "Dismiss",
    "UPDATE": {
      "ERROR": "Could not update settings, try again!",
      "SUCCESS": "Successfully updated account settings"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Fshi llogarinë tuaj",
      "NOTE": "Sapo të fshini llogarinë tuaj, të gjitha të dhënat tuaja do të fshihen.",
      "BUTTON_TEXT": "Fshi llogarinë tuaj",
      "CONFIRM": {
        "TITLE": "Fshi llogarinë",
        "MESSAGE": "Fshirja e llogarisë suaj është e pakthyeshme. Vendosni emrin e llogarisë tuaj më poshtë për të konfirmuar që doni ta fshini përgjithmonë.",
        "BUTTON_TEXT": "Fshi",
        "DISMISS": "Anulo",
        "PLACE_HOLDER": "Shkruani {accountName} për të konfirmuar"
      },
      "SUCCESS": "Llogaria u shënua për fshirje",
      "FAILURE": "Llogaria nuk mund të fshihej, provoni përsëri!",
      "SCHEDULED_DELETION": {
        "MESSAGE_MANUAL": "Kjo llogari është planifikuar për fshirje më {deletionDate}. Kjo u kërkua nga një administrator. Mund ta anuloni fshirjen para këtij datë.",
        "MESSAGE_INACTIVITY": "Kjo llogari është planifikuar për fshirje më {deletionDate} për shkak të mosveprimtarisë së llogarisë. Mund ta anuloni fshirjen para këtij datë.",
        "CLEAR_BUTTON": "Anulo fshirjen e planifikuar"
      }
    },
    "FORM": {
      "ERROR": "Please fix form errors",
      "GENERAL_SECTION": {
        "TITLE": "General settings",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "Account ID",
        "NOTE": "This ID is required if you are building an API based integration"
      },
      "NAME": {
        "LABEL": "Account name",
        "PLACEHOLDER": "Your account name",
        "ERROR": "Please enter a valid account name"
      },
      "LANGUAGE": {
        "LABEL": "Site language",
        "PLACEHOLDER": "Your account name",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Incoming Email Domain",
        "PLACEHOLDER": "The domain where you will receive the emails",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Support Email",
        "PLACEHOLDER": "Your company's support email",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Number of days after a ticket should auto resolve if there is no activity",
        "NOTE": "Numri i orëve të mosveprimtarisë pas të cilave çdo bisedë e hapur zgjidhet automatikisht.",
        "PLACEHOLDER": "30",
        "ERROR": "Please enter a valid auto resolve duration (minimum 1 day and maximum 999 days)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Numri i ditëve pas të cilave një bisedë e zbrazët zgjidhet automatikisht nëse nuk ka veprimtari",
        "PLACEHOLDER": "kurrë",
        "ERROR": "Vendosni një kohëzgjatje të vlefshme për zgjidhjen automatike (minimumi 1 ditë dhe maksimumi 999 ditë)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Conversation continuity with emails is enabled for your account.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "You can receive emails in your custom domain now."
      },
      "PHONE": {
        "TITLE": "Cilësimet e PBX-së",
        "NOTE": "Konfiguroni lidhjen me PBX-në tuaj për thirrjet telefonike",
        "SIP_HOST": {
          "LABEL": "Domeni SIP"
        },
        "DIALING_MODE": {
          "LABEL": "Mënyra e thirrjes",
          "MODES": {
            "direct": "Direkte – thirrja bëhet menjëherë kur klikohet lidhja e telefonit",
            "indirect": "Indirekte – numri i telefonit përgatitet në kutinë e hyrjes së widget-it të telefonit"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Qasja te regjistrimet e thirrjeve",
          "MODES": {
            "admin_only": "Vetëm administratorët",
            "admin_and_assigned_agent": "Administratorët dhe agjenti i caktuar",
            "inbox_members": "Të gjithë agjentët me qasje në kutinë hyrëse"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Cilësimet e email-it",
        "NOTE": "Ndryshon sjelljen e kutive hyrëse të email-it"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Mënyra e shfaqjes së kohës së bisedës",
        "MODES": {
          "both": "Krijimi dhe veprimtaria e fundit",
          "last_activity_only": "Vetëm veprimtaria e fundit",
          "last_customer_message": "Mesazhi i fundit i klientit"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Blloko domenet me reputacion të ulët"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Përfshi mesazhin origjinal në përgjigjen e email-it"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Zgjidh automatikisht një bisedë të re"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Zhvendos automatikisht një bisedë të re me email në kutinë e robotit që përpunoi porositë e kontaktit"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Etiketa të zgjeruara – lejo emra etiketash më të gjatë me ndërfaqe më të madhe kërcyese"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent – cakto automatikisht bisedën te agjenti që dha përgjigjen e fundit"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Mënyra e njoftimeve push",
        "MODES": {
          "all_inboxes": "Të gjitha kutitë hyrëse – dërgo njoftime për të gjitha llojet e kanaleve",
          "chat_only": "Vetëm chat – dërgo njoftime vetëm për kanalet jo-email"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Lejo aktivizimin/çaktivizimin e nënshkrimit në mesazhet e dërguara"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Shfaq statusin e chat-it të agjentit në wallboard"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Shfaq emrat e plotë të bashkëngjitjeve pa i shkurtuar"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Hyrje me fjalëkalim",
        "MODES": {
          "allowed_for_all": "E lejuar për të gjithë përdoruesit",
          "allowed_for_agents_only": "E lejuar vetëm për agjentët (administratorët duhet të përdorin OAuth)",
          "password_login_disabled": "Çaktivizuar – vetëm OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Ka një version të ri. Rifreskoni faqen për të marrë përditësimet më të fundit.",
    "RELOAD_NOW": "Përditëso tani",
    "LEARN_MORE": "Learn more",
    "PAYMENT_PENDING": "Pagesa juaj është në pritje. Përditësoni të dhënat e pagesës për të vazhduar përdorimin e qendrës së kontaktit",
    "LIMITS_UPGRADE": "Llogaria juaj ka tejkaluar kufijtë e përdorimit. Përmirësoni planin tuaj për të vazhduar përdorimin e qendrës së kontaktit",
    "OPEN_BILLING": "Open billing"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Press enter to select",
      "ENTER_TO_REMOVE": "Press enter to remove",
      "NO_OPTIONS": "Lista është bosh",
      "NO_RESULT": "Nuk u gjetën rezultate",
      "SELECT_ONE": "Select one",
      "SELECT": "Zgjidh"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Notifications",
    "MARK_ALL_DONE": "Mark All Done",
    "DELETE_TITLE": "deleted",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Unread Notifications",
      "ALL_NOTIFICATIONS": "View all notifications",
      "LOADING_UNREAD_MESSAGE": "Loading unread notifications...",
      "EMPTY_MESSAGE": "You have no unread notifications"
    },
    "LIST": {
      "LOADING_MESSAGE": "Loading notifications...",
      "404": "No Notifications",
      "TABLE_HEADER": [
        "Name",
        "Phone Number",
        "Conversations",
        "Last Contacted"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "New conversation",
      "conversation_assignment": "Conversation Assigned",
      "assigned_conversation_new_message": "New Message",
      "participating_conversation_new_message": "New Message",
      "conversation_mention": "Mention",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Offline",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Refresh"
    },
    "CONNECTION_LOST": {
      "TITLE": "Lidhja u ndërpre",
      "DESCRIPTION": "Nuk arritëm të lidhemi me serverin. Kontrolloni lidhjen dhe provoni përsëri.",
      "RETRY": "Provo përsëri"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Search or jump to",
    "SECTIONS": {
      "GENERAL": "General",
      "REPORTS": "Reports",
      "CONVERSATION": "Conversation",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Change Assignee",
      "CHANGE_PRIORITY": "Change Priority",
      "CHANGE_TEAM": "Change Team",
      "SNOOZE_CONVERSATION": "Snooze Conversation",
      "EXECUTE_MACRO": "Ekzekuto makro",
      "ADD_LABEL": "Add label to the conversation",
      "REMOVE_LABEL": "Remove label from the conversation",
      "SETTINGS": "Settings",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Go to Conversation Dashboard",
      "GO_TO_CONTACTS_DASHBOARD": "Go to Contacts Dashboard",
      "GO_TO_REPORTS_OVERVIEW": "Go to Reports Overview",
      "GO_TO_CONVERSATION_REPORTS": "Go to Conversation Reports",
      "GO_TO_AGENT_REPORTS": "Go to Agent Reports",
      "GO_TO_LABEL_REPORTS": "Go to Label Reports",
      "GO_TO_INBOX_REPORTS": "Go to Inbox Reports",
      "GO_TO_TEAM_REPORTS": "Go to Team Reports",
      "GO_TO_SETTINGS_AGENTS": "Go to Agent Settings",
      "GO_TO_SETTINGS_TEAMS": "Go to Team Settings",
      "GO_TO_SETTINGS_INBOXES": "Go to Inbox Settings",
      "GO_TO_SETTINGS_LABELS": "Go to Label Settings",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Go to Canned Response Settings",
      "GO_TO_SETTINGS_APPLICATIONS": "Go to Application Settings",
      "GO_TO_SETTINGS_ACCOUNT": "Go to Account Settings",
      "GO_TO_SETTINGS_PROFILE": "Go to Profile Settings",
      "GO_TO_NOTIFICATIONS": "Go to Notifications",
      "ADD_LABELS_TO_CONVERSATION": "Add label to the conversation",
      "ASSIGN_AN_AGENT": "Assign an agent",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Assign priority",
      "ASSIGN_A_TEAM": "Assign a team",
      "EXECUTE_A_MACRO": "Ekzekuto një makro",
      "MUTE_CONVERSATION": "Mute conversation",
      "UNMUTE_CONVERSATION": "Unmute conversation",
      "REMOVE_LABEL_FROM_CONVERSATION": "Remove label from the conversation",
      "REOPEN_CONVERSATION": "Reopen conversation",
      "RESOLVE_CONVERSATION": "Resolve conversation",
      "SEND_TRANSCRIPT": "Send an email transcript",
      "SNOOZE_CONVERSATION": "Snooze Conversation",
      "UNTIL_NEXT_REPLY": "Until next reply",
      "UNTIL_NEXT_WEEK": "Until next week",
      "UNTIL_TOMORROW": "Until tomorrow",
      "UNTIL_NEXT_MONTH": "Until next month",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Loading Dashboard App..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "click here"
  }
}
